/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.piesync.bridge.rpc.AppsRpc
 */

export const getAllRpc = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.AppsRpc',
  rpcName: 'getAll',
  auth: 'app',
  fingerprint: 'AAAAAAAAAADPyoXw2hW7u-xBqVstM-Aa',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAppRpc = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.AppsRpc',
  rpcName: 'getApp',
  auth: 'app',
  fingerprint: 'KPFzaoVrp822byeq4IG5AyrM0ULITvWP',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};